<template>
	<div class="group-radio">
		<div v-for="(item, index) in data" :key="index" class="group-radio-item" :class="{ 'active': modelValue === item[settings.valueField] }" @click="changeValue(item)">
			{{ item[settings.displayField] }}
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		name: 'GroupRadio',
		props: {
			data: { type: Array, default: () => [] },
			modelValue: { type: String },
			options: { type: Object }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					displayField: 'name',
					valueField: 'value'
				}
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
		},
		methods: {
			changeValue(item) {
				this.$emit('update:modelValue', item[this.settings.valueField])
			}
		},

	}
</script>

<style lang="less">
	@import "../styles/group-radio.less";
</style>